document.addEventListener('DOMContentLoaded', () => {
  const v2Modal = document.querySelector('.plans-v2');
  if (v2Modal) {
    const targetHref = `#${v2Modal.id}`;
    document.querySelectorAll('a[href="#compare-plans"]').forEach(link => {
      link.setAttribute('href', targetHref);
    });
  }

  document.querySelectorAll('.plans-v2__viewport').forEach(el => {
    if (typeof Swiper === 'undefined') return;

    const initialSlide = parseInt(el.dataset.initialSlide, 10) || 0;
    const mql = window.matchMedia('(min-width: 768px)');
    let swiperInstance = null;

    const enableSwiper = () => {
      if (swiperInstance) return;
      swiperInstance = new Swiper(el, {
        wrapperClass: 'plans-v2__track',
        slideClass: 'plans-v2__slide',
        slidesPerView: 1,
        spaceBetween: 12,
        initialSlide,
        pagination: {
          el: el.querySelector('.plans-v2__pagination'),
          clickable: true,
        },
      });
    };

    const disableSwiper = () => {
      if (!swiperInstance) return;
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    };

    const handleChange = e => (e.matches ? disableSwiper() : enableSwiper());
    handleChange(mql);
    mql.addEventListener('change', handleChange);
  });

  const membershipCheckbox = document.querySelector('.membership-offer .mt-form-offer__checkbox input');
  const ctaButtons = document.querySelectorAll('.plans-v2 [data-activate-membership]');

  const syncCtaState = () => {
    const isSelected = !!membershipCheckbox?.checked;
    ctaButtons.forEach(btn => btn.classList.toggle('is-selected', isSelected));
  };

  if (membershipCheckbox) {
    membershipCheckbox.addEventListener('change', syncCtaState);
    syncCtaState();
  }

  document.querySelectorAll('.plans-v2').forEach(modal => {
    modal.querySelectorAll('[data-activate-membership]').forEach(btn => {
      btn.addEventListener('click', () => {
        if (!membershipCheckbox || btn.classList.contains('is-loading')) return;
        const wasSelected = membershipCheckbox.checked;
        btn.classList.add('is-loading');

        setTimeout(() => {
          btn.classList.remove('is-loading');

          membershipCheckbox.checked = !wasSelected;
          membershipCheckbox.dispatchEvent(new Event('change'));

          if (!wasSelected) {
            window.app?.modal?.close(modal);
          }
        }, 500);
      });
    });
  });
});
